var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTransactionLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 9.20841C6.55664 9.20841 7.04167 8.72339 7.04167 8.12508C7.04167 7.52677 6.55664 7.04175 5.95833 7.04175C5.36002 7.04175 4.875 7.52677 4.875 8.12508C4.875 8.72339 5.36002 9.20841 5.95833 9.20841Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20831 7.04175H21.125M9.20831 9.20841H15.7083",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 14.0834C6.55664 14.0834 7.04167 13.5984 7.04167 13.0001C7.04167 12.4018 6.55664 11.9167 5.95833 11.9167C5.36002 11.9167 4.875 12.4018 4.875 13.0001C4.875 13.5984 5.36002 14.0834 5.95833 14.0834Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20831 11.9167H17.875M9.20831 14.0834H16.7916",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.95833 18.9584C6.55664 18.9584 7.04167 18.4734 7.04167 17.8751C7.04167 17.2768 6.55664 16.7917 5.95833 16.7917C5.36002 16.7917 4.875 17.2768 4.875 17.8751C4.875 18.4734 5.36002 18.9584 5.95833 18.9584Z",
    stroke: "white",
    strokeOpacity: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.20831 16.7917H19.5M9.20831 18.9584H13.5416",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionLogo);
export default __webpack_public_path__ + "static/media/transaction-logo.ce77ffeb1236ff69451e8367f0bf9ba9.svg";
export { ForwardRef as ReactComponent };